import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getRecaptchaToken } from '../utils/recaptchaEnterprise';
import { verifyTokenOnServer } from '../utils/recaptchaVerify';

export default function Register() {
  const { signup, loginWithGoogle, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!authLoading && user) navigate('/');
  }, [authLoading, user, navigate]);
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleGoogle = async () => {
    setGoogleLoading(true);
    setError('');
    try {
      await loginWithGoogle();
      navigate('/');
    } catch (err) {
      setError(err?.message || 'Google sign-in failed');
    } finally {
      setGoogleLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    setError('');
    try {
      // Get a reCAPTCHA Enterprise token for the REGISTER action
      try {
        const action = 'REGISTER';
        const siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY || '6Lc7PO8rAAAAALb_xbeAQJt0qxid5YASCC9oF86P';
        const token = await getRecaptchaToken(action, siteKey);
        const res = await verifyTokenOnServer({ token, action, siteKey });
        if (res && res.ok === false) {
          throw new Error('reCAPTCHA verification failed');
        }
      } catch (rcErr) {
        console.warn('reCAPTCHA verify skipped/failed:', rcErr?.message || rcErr);
      }
      await signup(email, password, displayName);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Failed to create account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ paddingTop: '4rem', display: 'flex', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit} className="glass-card form-glass" style={{ padding: 24 }}>
        <h2 className="card-title" style={{ marginTop: 0 }}>Create Account</h2>
  {error && <div className="meta-text" style={{ color: '#ff6b6b', marginBottom: 8 }}>{error}</div>}
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 12 }}>
          <span className="form-label">Display name (optional)</span>
          <input
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Ezra Dixon"
            className="input-glass"
          />
        </label>
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 12 }}>
          <span className="form-label">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input-glass"
          />
        </label>
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 12 }}>
          <span className="form-label">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input-glass"
          />
        </label>
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 16 }}>
          <span className="form-label">Confirm password</span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className="input-glass"
          />
        </label>
        <button disabled={loading} type="submit" className="btn-glass-primary btn-block">
          {loading ? 'Creating…' : 'Sign Up'}
        </button>

        <div className="meta-text" style={{ marginTop: 10, opacity: 0.8 }}>or</div>
        <button
          type="button"
          className="btn-glass-secondary btn-google"
          disabled={loading || googleLoading}
          onClick={handleGoogle}
        >
          <span className="btn-google-badge" aria-hidden>G</span>
          {googleLoading ? 'Opening Google…' : 'Continue with Google'}
        </button>
        <p className="meta-text" style={{ marginTop: 12 }}>
          Already have an account? <Link to="/login" style={{ color: '#00bcd4' }}>Log in</Link>
        </p>
      </form>
    </div>
  );
}
